<template>
    <div class="home">
        <div class="banner">
            <img src="../../assets/image/home/banner2.png" alt="" />
            <!-- <div class="cover">
        <span> 淮河能源控股集团期待您的加入</span>
      </div> -->
        </div>
        <div class="content">
            <div class="top">
                <span style="font-size: 22px; font-weight: 700">招聘活动</span>
                <span @click="more()" style="font-size: 14px; color: #666; cursor: pointer">查看更多 >></span>
            </div>
            <div>
                <div v-for="(item, index) in activityList" :key="index">
                    <activity
                        :id="item.zphdid"
                        :title="item.zphdmc"
                        :showIcon="item.showIcon"
                        :startDate="item.zphdbmkssj"
                        :endDate="item.zphdbmjssj"
                        :showEnd="item.hdzt"
                        :date="item.zphdfbsj"
                        :type="item.zphdlx"
                        :zplb="item.zplb"
                    ></activity>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import activity from "@/components/activity";
import request from "@/api/home.js";
import share from "@/assets/sharejs/share.js";
export default {
    components: {
        activity,
    },
    data() {
        return {
            activityList: [],
        };
    },
    mounted() {
        this.getZphd();
        this.getAllCode();
    },
    methods: {
        getAllCode() {
            request
                .getAllCode()
                .then(function(data) {
                    sessionStorage.setItem(
                        "whether",
                        JSON.stringify([
                            { value: "是", key: "1" },
                            { value: "否", key: "0" },
                        ])
                    );
                    sessionStorage.setItem(
                        "jg",
                        JSON.stringify([
                            { value: "通过", key: "1" },
                            { value: "未通过", key: "0" },
                        ])
                    );
                    share.set("whether", [
                        { value: "是", key: "1" },
                        { value: "否", key: "0" },
                    ]);
                    share.set("zpqszt", data.ZPQSZT); //招聘启事状态
                    share.set("zpgwlx", data.ZPGWLX); //招聘岗位类型
                    share.set("xb", data.XB); //性别
                    share.set("mz", data.MZ); //民族
                    share.set("zzmm", data.ZZMM); //政治面貌
                    share.set("xl", data.XL); //学历
                    share.set("xw", data.XW); //学位
                    share.set("xz", data.XZ); //学制
                    share.set("lb", data.LB); //学校类别
                    share.set("ybrgx", data.YBRGX); //与本人关系
                    share.set("shjg", data.SHJG); //审核结果
                    share.set("lqjg", data.LQJG); //录取结果
                    share.set("ssbk", data.SSBK); //所属板块
                    share.set("yxzjlx", data.YXZJLX); //有效证件类型
                    share.set("tjjg", data.TJJG); //体检结果
                    share.set("qyzt", data.QYZT); //签约状态
                    // share.set("zpqsmc", data.ZPQSMC);//招聘启事名称
                    share.set("sfqdwkcdx", data.SFQDWKCDX); //是否确认为考察对象
                    share.set("sfwhbdtz", data.SFWHBDTZ); //是否维护报到通知
                    share.set("zpjhzt", data.ZPJHZT); //招聘计划状态
                    share.set("sfwhzpzy", data.SFWHZPZY); //是否维护招聘专业
                    share.set("sfqrcjbs", data.SFQRCJBS); //是否确认参加笔试
                    share.set("yysp", data.YYSP); //英语水平
                    share.set("jsjsp", data.JSJSP); //计算机水平
                    share.set("jyxs", data.JYXS); //计算机水平
                    share.set("zylb", data.ZYLB); //专业类别
                    share.set("sl", data.SL); //视力
                    share.set("sg", data.SG); //身高
                    share.set("tz", data.TZ); //体重
                    share.set("mkjxgznx", data.MKJXGZNX); //煤矿井下工作年限
                    share.set("xggwzgjndj", data.XGGWZGJNDJ); //煤矿井下工作年限
                    console.log("response");
                    console.log(data);
                })
                .catch(function(error) {
                    console.log("error");
                    console.log(error);
                });
        },
        /**
         * 获取招聘活动
         */
        getZphd() {
            let param = {
                page: "1",
                pageSize: "5",
            };
            let that = this;
            request
                .getZphd(param)
                .then(function(data) {
                    that.activityList = data.vds;
                    console.log("response");
                    console.log(data);
                })
                .catch(function(error) {
                    console.log("error");
                    console.log(error);
                });
        },
        /* 查看更多 */
        more() {
            this.$router.push("/recruitmentActivity");
        },
    },
};
</script>
<style lang="scss" scoped>
.home {
    background: #f7f9fa;
    .cover {
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 31%;
        width: 50%;
        height: 25%;
        left: 23%;
        color: #fffafa;
        font-size: 33px;
        // text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .content {
        width: 80%;
        margin: 20px auto;
        padding: 20px;
        background: #fff;
        box-sizing: border-box;
        .top {
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: 1px solid #d9d9d9;
        }
    }
}
.banner {
    position: relative;
    width: 80%;
    margin: 20px auto;
    //   height: 369px;
    img {
        width: 100%;
        height: 100%;
    }
}
</style>
